import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const Wrapper = styled.div`
  // padding-top: 17px;
  // padding-right: 42px;
  // padding-left: 42px;
 
  background: ${Colors.background_secondary};
  border-radius: 2px;
  // box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  max-width: 100vw;
  // margin-bottom: 32px;
`;

const WrapperBottomComponents = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const TextTitleWrapper = styled.div`
  margin-bottom: 13px;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
`;

const DataTimeSelector = styled.div`
  height: 41px;
  box-sizing: border-box;
  display: flex;
  background: ${Colors.background_secondary};
  margin-bottom: 17px;
  margin-right: 13px;
`;

const DateTimeSelectorItem = styled.div`
  padding-left: 19px;
  padding-right: 19px;
  color: ${(props) =>
    (props.selected ? Colors.text_on_primary : Colors.text_primary)};
  background: ${(props) => (props.selected ? Colors.primary_web : 'none')};
  display: grid;
  place-content: center;
  cursor: pointer;
  ${(props) =>
    (props.selected
      ? ''
      : `border-top: 0.5px solid ${Colors.text_secondary}; 
    border-bottom: 0.5px solid ${Colors.text_secondary};
    border-right: 0.5px solid ${Colors.text_secondary};
    `)}
  ${(props) =>
    (props.left && !props.selected
      ? `
 border-left: 0.5px solid ${Colors.text_secondary};
 `
      : '')}
${(props) =>
    (props.nextSelected
      ? `
      border-right: none;
 `
      : '')}
`;

const WrapperDatePicker = styled.div`
  margin-bottom: 17px;
  border: 0.5px solid ${Colors.text_secondary};
  box-sizing: border-box;
  border-radius: 2px;
  width: 280px;
  display: flex;
  height: 41px;
  position: relative;
  & input {
    text-align: center;
  }
`;

const IconArrowWrapper = styled.div`
  padding-left: 9px;
  padding-right: 9px;
  height: 100%;
  display: grid;
  place-content: center;
  cursor: pointer;
  z-index: 1;
`;

const MoreOptionsIconWrapper = styled.div`
  height: 41px;
  display: grid;
  place-content: center;
  padding-left: 8.5px;
  padding-right: 8.5px;
`;

export default {
  Wrapper,
  DataTimeSelector,
  DateTimeSelectorItem,
  TextTitleWrapper,
  WrapperBottomComponents,
  WrapperDatePicker,
  IconArrowWrapper,
  MoreOptionsIconWrapper,
};
